import { render } from "./EditQuestionModal.vue?vue&type=template&id=0ff09452"
import script from "./EditQuestionModal.vue?vue&type=script&lang=js"
export * from "./EditQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__